
import Division from './Division'
import Designation from './Designation'
import { Users2 } from 'lucide-react'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'

function TeamSettings() {
    return(
        <>
                     <HeadingWithIcon icon={Users2} title="Team" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Division/>
         </div>
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Designation/>
         </div>
        
       
         </div>
         </>
    )
}

export default TeamSettings
